import { resources } from "@constants/hardcoded-strings";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { Dispatch } from "redux";
import { AxnCompany } from "@idw-types/data/reference-data/axn";
import { GenericAccountStateTypes } from "@enums/generic-account-state-types";
import { updateOrganizations } from "@redux/actions/organizations-actions";
import { archiveOrganizationRequest } from "@requests/archive-organization";

export const archiveOrganizationReduxRequest = (dispatch: Dispatch) => async (
    organizationId: string
): Promise<AxnCompany> => {
    const { data, error } = await archiveOrganizationRequest(organizationId);
    if (data) {
        displaySuccessModal(
            dispatch,
            resources.requests.archiveOrganization.success.title,
            resources.requests.archiveOrganization.success.message
        );
        dispatch(updateOrganizations(data.transferObject, GenericAccountStateTypes.ARCHIVE));
        return data.transferObject;
    } else {
        if (error) {
            const errorResource = resources.requests.archiveOrganization.error;

            logAndDisplayErrorModal(
                dispatch,
                error,
                errorResource.title,
                errorResource.message
            );
        }
    }

    return null;
};